<template>
	<div id="app">
		<!-- 如果需要全局导航栏，可以在这里添加 -->
		<Header v-if="showHeader" />

		<!-- 路由视图 -->
		<router-view />

		<!-- 如果需要全局页脚，可以在这里添加 -->
		<!-- <Footer v-if="showFooter" /> -->
	</div>
</template>
<script>
	import Header from '@/components/Header.vue'
	import Footer from '@/components/Footer.vue'
	export default {
		name: 'App',
		components: {
			Header,
			Footer
		},
		computed: {
			showHeader() {
				console.log(this.$route.name)
				// 可以根据路由决定是否显示导航栏
				return !['Login', 'register'].includes(this.$route.name)
			},
			showFooter() {
				// 可以根据路由决定是否显示页脚
				return !['Login', 'register'].includes(this.$route.name)
			}
		}
	}
</script>

<style>
	#app {
		font-family: -apple-system, BlinkMacSystemFont, 'SF Pro Display', 'Segoe UI', 'PingFang SC', 'Microsoft YaHei', sans-serif;
		background: linear-gradient(135deg, #EBF5FF 0%, #F0F9FF 50%, #FFF7ED 100%);
		color: #111827;
		line-height: 1.6;
		min-height: 100vh;
	}

	/* CSS变量定义 */
	:root {

		--primary: #2E5CE6;
		--primary-dark: #1E3A8A;
		--primary-light: #60A5FA;
		--secondary: #10B981;
		--accent: #06B6D4;
		--purple: #8B5CF6;
		--pink: #EC4899;
		--orange: #F59E0B;
		--asean: #D97706;
		--china-red: #4d53e8;
		--success: #10B981;
		--warning: #F59E0B;
		--danger: #EF4444;
		--bg-white: #FFFFFF;
		--bg-gray-50: #F9FAFB;
		--bg-gray-100: #F3F4F6;
		--bg-gray-200: #E5E7EB;
		--bg-gradient: linear-gradient(135deg, #EBF5FF 0%, #F0F9FF 50%, #FFF7ED 100%);
		--text-primary: #111827;
		--text-secondary: #6B7280;
		--text-tertiary: #9CA3AF;
		--border-light: #E5E7EB;
		--border-medium: #D1D5DB;
		--shadow-xs: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
		--shadow-sm: 0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06);
		--shadow-md: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
		--shadow-lg: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);
		--shadow-xl: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);
		--shadow-2xl: 0 25px 50px -12px rgba(0, 0, 0, 0.25);
		--radius-sm: 8px;
		--radius-md: 12px;
		--radius-lg: 16px;
		--radius-xl: 24px;
		--radius-2xl: 32px;
		--transition-base: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);



		--primary-blue: #0d47a1;
		--secondary-blue: #1565c0;
		--accent-blue: #1976d2;
		--light-blue: #e3f2fd;
		--text-dark: #263238;
		--text-light: #546e7a;
		--white: #ffffff;
		--gray-light: #f5f5f5;
		--gray-border: #e0e0e0;
		--success: #2e7d32;
		--warning: #f57c00;
		--glass-white: rgba(255, 255, 255, 0.9);
		--glass-blue: rgba(13, 71, 161, 0.05);
		--danger: #d32f2f;
		--ff-coin-gold: #FFD700;
		--ff-coin-shadow: #B8860B;
	}

	* {
		margin: 0;
		padding: 0;
	}

	body,
	html {
		height: 100%;
	}

	.main-container {
		max-width: 1200px;
		margin: 80px auto 0;
		padding: 40px 20px;
	}
</style>
